import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import PageTitle from '@/components/PageTitle/PageTitle';

import IntellectualPropertyPageHeaderMeta from './IntellectualPropertyPageHeaderMeta';

type ContactInfoRow = {
    key: string;
    label: string;
    value: ReactNode;
};

const CONTACT_DATA: ContactInfoRow[] = [
    {
        key: 'legal-name',
        label: 'Legal name and address:',
        value: (
            <>
                Live Auctioneers LLC
                <br />
                270 Madison Avenue, Suite 1500
                <br />
                New York, NY 10016
            </>
        ),
    },
    {
        key: 'dba',
        label: 'Names doing business under:',
        value: 'Live Auctioneers LLC',
    },
    {
        key: 'agent',
        label: 'Designated Agent:',
        value: 'Legal Department',
    },
    {
        key: 'agent-address',
        label: 'Address of Agent:',
        value: (
            <>
                Live Auctioneers LLC
                <br />
                270 Madison Avenue, Suite 1500
                <br />
                New York, NY 10016
            </>
        ),
    },
    {
        key: 'telephone',
        label: 'Telephone:',
        value: (
            <Link
                className="hui-text-body-secondary text-link-primary"
                href="tel:18886002437"
            >
                1-888-600-BIDS
            </Link>
        ),
    },
    {
        key: 'fax',
        label: 'Fax:',
        value: '212-947-0184',
    },
    {
        key: 'email',
        label: 'Email for notice:',
        value: (
            <Link
                className="hui-text-body-secondary"
                href="mailto:legal@auctiontechnologygroup.com"
            >
                legal@auctiontechnologygroup.com
            </Link>
        ),
    },
];

const IntellectualPropertyPage = () => {
    return (
        <div className="mx-auto max-w-dense px-md pb-lg">
            <IntellectualPropertyPageHeaderMeta />
            <div>
                <PageTitle title="Intellectual Property" />
                <p className="mb-md">
                    All materials including, but not limited to, content, images, photographs, data and intellectual
                    property on this site are protected by digital watermark technology and are the property of Live
                    Auctioneers, LLC ("LIVE"). The copying or duplicating of any item on this website including, but not
                    limited to, images or data is strictly prohibited and violators will be pursued and prosecuted to
                    the full extent of state, federal and international law including, but not limited to, the Digital
                    Millennium Copyright Act.
                </p>
                <p className="mb-md">
                    LIVE grants a limited license to access and make personal use of this site. Such license does not
                    permit the downloading or modification of this website or its consents, or any portion of this
                    website or its content, without the express written consent of LIVE. This license does not permit
                    the resale or commercial use of this site or its contents; the collection and use of product
                    listings, descriptions, or prices; derivative use of this site or its contents; downloading or
                    copying of account information for the benefit of another merchant; data mining, robots, or similar
                    data gathering and extraction tools. This site or any portion of this site may not be reproduced,
                    duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without
                    the express written consent of LIVE. Framing techniques to enclose trademarks, logos, or other
                    proprietary information (including images, text, page layout, or form) of LIVE and our affiliates is
                    also not permitted without express written consent. Any unauthorized use terminates the permission
                    or license granted by LIVE.
                </p>
                <H2 className="hui-text-h2 pb-sm pt-lg">DMCA Registered Agent</H2>
                <p className="mb-md">
                    Pursuant to § 201.38 of the Interim Regulation, Live Auctioneer&#39;s registered agent is as
                    follows:
                </p>
                <div className="my-sm w-[520px] max-w-full">
                    {CONTACT_DATA.map((row, index) => (
                        <div
                            className={cn(
                                'flex flex-col gap-2xs py-sm smMin:flex-row smMin:items-center',
                                index !== CONTACT_DATA.length - 1 && 'border-b border-border-primary'
                            )}
                            key={row.key}
                        >
                            <div className="w-60 font-medium text-text-secondary">{row.label}</div>
                            <div>{row.value}</div>
                        </div>
                    ))}
                </div>
                <p className="mb-md">
                    This information is provided to help owners of intellectual property report potentially infringing
                    items on Live Auctioneers, under the notice requirements of the Digital Millennium Copyright Act.
                </p>
                <p className="mb-md">
                    <i>License renewal date July 7, 2029</i>
                </p>
            </div>
        </div>
    );
};

export default IntellectualPropertyPage;
